import NgwConnector from '@nextgis/ngw-connector';

import { config } from '../config';

let connector: NgwConnector;
if (process.env.CLIENT_TYPE === 'solo') {
  connector = new NgwConnector({
    baseUrl: config.baseUrl, // 'http://mggt.staging.nextgis.com',
    auth: config.auth, //{ login: 'administrator', password: 'admin' },
  });
} else {
  connector = new NgwConnector({
    baseUrl: '',
  });
}

export { connector };
